import routes from "../Customer/customerRoutes"
import {FeatureFlags, isFeatureEnabled} from "../../Utils/featureFlags";
import modals from "../modals";

export const customerNavigationItems = {
    Customer: {id: 1, title: 'customernavigation.customer', route: " "},
    EditCustomer: {
        id: 2,
        title: 'customernavigation.editcustomer',
        route: routes.Edit,
        hiddenFunc: (params) => true, // Was VOSS-feature flag. Remove EditCustomer?
        disabledFunc: (params) => params.customer?.vonCustomer?.isNonInteractive
    },
    RelatedCustomer: {
        id: 3,
        title: 'customernavigation.relatedcustomers',
        route: routes.relatedCustomers,
        disabledFunc: (params) => params.customer?.vonCustomer?.isNonInteractive || !params.customer?.orgNo
    },
    Agreements: {id: 4, title: 'customernavigation.agreements', route: routes.Agreements},
    Users: {
        id: 5,
        title: 'customernavigation.users',
        route: routes.Users,
        disabledFunc: (params) => !params.customer?.vonCustomer && !params.customer?.vossCustomer
    },
    Collaborations: {
        id: 6,
        title: 'customernavigation.collaborations',
        route: routes.Collaborations,
        disabledFunc: (params) => !params.customer?.vonCustomer
    },
    PlaceOrder: {id: 7, title: 'customernavigation.placeorder', route: routes.orderPlacement},
    Leads: {
        id: 8,
        title: 'customernavigation.leads',
        route: routes.Leads,
        badgeFunc: (params) => params.customerInfoCounts?.['openLeads']
    },
    Appointments: {
        id: 9,
        title: 'customernavigation.appointments',
        route: routes.Appointments,
        badgeFunc: (params) => params.customerInfoCounts?.['openAppointments'],
        disabledFunc: (params) => !params.customer?.vbCustomer
    },
    Campaigns: {id: 10, title: 'customernavigation.emails', route: routes.Campaign,
        disabledFunc: (params) => !params.customer?.vbCustomer},
    Courses: {id: 11, title: 'customernavigation.educations', route: routes.EducationsCourses},
    Onboarding: {id: 12, title: 'customernavigation.onboarding', route: routes.EducationsOnboardings},
    EmailForms: {id: 13, title: 'customernavigation.emailforms', route: routes.AdminForms},
    DesktopVersion: {
        id: 15,
        title: 'customernavigation.senddesktopkey',
        route: routes.SendDesktopVersion,
        disabledFunc: (params) => !params.customer?.vbCustomer
    },
    Compensation: {
        id: 16,
        title: 'customernavigation.compensation',
        route: routes.Compensation,
        badgeFunc: (params) => params.customerInfoCounts?.['compensationHistoryCount'],
        disabledFunc: (params) => !params.customer?.vbCustomer
    },
    Consulting: {
        id: 17,
        title: 'customernavigation.consulting',
        route: routes.Consulting,
        disabledFunc: (params) => !params.customer?.vbCustomer
    },
    Invoices: {id: 18, title: 'customernavigation.invoices', route: routes.Invoices,
        disabledFunc: (params) => !params.customer?.vbCustomer},
    Salesforce: {
        id: 19,
        title: 'customernavigation.salesforce',
        routeFunc: (params) => params.externalUrls['salesForce'],
        redirect: true
    },
    EducationCode: {
        id: 20,
        title: 'customernavigation.educationCode',
        route: routes.EducationCode,
        disabledFunc: (params) => !params.customer?.vonCustomer
    },
    AiAssistant: {
        id: 21,
        title: 'customernavigation.aiassistant',
        routeFunc: (params) => params.externalUrls['aiAssistant'],
        redirect: true
    },
    Logging: {
        id: 22,
        title: 'customernavigation.log',
        route: routes.Log
    },
    Discounts: {
        id: 24,
        title: 'customernavigation.discounts',
        routeFunc: (params) => routes.VossDiscounts,
        disabledFunc: (params) => !params.customer?.vossCustomer
    },
    CompanyData: {
        id: 26,
        title: 'customernavigation.inyettdetails',
        route: routes.inyettdetails,
        disabledFunc: (params) => !params.customer?.orgNo
    },
    UpdateAddress: {
        id: 27,
        title: 'customernavigation.updateaddress',
        onClickFunc: (params) => {
            params.customerActions.getCustomerInfoForUpdate(params.customer?.orgNo)
        },
        disabledFunc: (params) => params.customer?.vonCustomer?.isNonInteractive || !params.customer?.orgNo || params.customer?.orgNo === "5555555555"
    },
    SendLeads: {
        id: 28, title: 'customernavigation.sendleads', onClickFunc: (params) => {
            params.customerActions.setInternalLeadsEmailTemplate("InternalLead");
            params.openModal(modals.SendLeads);
        },
    },
    InternalAdmin: {
        id: 29,
        title: 'customernavigation.internaladministration',
        routeFunc: (params) => `${params.externalUrls['internalAdmin']}${params.customer?.vbCustomer?.customerNumber}`,
        redirect: true,
        hiddenFunc: (params) => true // Was VOSS-feature flag. Remove InternalAdmin?
    },
    FileBox: {
        id: 30, title: 'customernavigation.filebox',
        disabledFunc: (params) => !params.customer?.vbCustomer, routeFunc: (params) => {
            if (!params.customer?.vbCustomer)
                return params.externalUrls['fileBox'];

            let vbCustomer = params.customer.vbCustomer

            const searchParams = new URLSearchParams();

            searchParams.append("customernumber", vbCustomer.customerNumber);
            searchParams.append("email", vbCustomer.email);
            searchParams.append("phone", vbCustomer.contactPerson.phoneNumber);
            searchParams.append("customername", vbCustomer.name);

            return `${params.externalUrls['fileBox']}/case/open?${searchParams.toString()}`
        }, redirect: true
    },
    Movies: {id: 31, title: 'customernavigation.movies', route: routes.EducationsMovies, disabledFunc: (params) => !params.customer?.vbCustomer},
    IntegrationPartners: {
        id: 32,
        title: 'customernavigation.integrationpartners',
        routeFunc: (params) => params.externalUrls['integrationPartners'],
        redirect: true
    },
    Retailer: {
        id: 33,
        title: 'customernavigation.retailer',
        routeFunc: (params) => params.externalUrls['retailer'],
        redirect: true
    },
    TerminationOfAdditionalUsersOnPrem: {
        id: 34,
        title: 'customernavigation.terminationonprem',
        routeFunc: (params) => params.externalUrls['terminationOnPrem'],
        redirect: true
    },
    ConnectSupportTool: {
        id: 35,
        title: 'customernavigation.connectsupporttool',
        routeFunc: (params) => params.externalUrls['connectSupportTool'],
        redirect: true
    }
};

export const categorizedCustomerNavigationItems = [
    {
        link: {
            title: 'common.customer',
            subItems: [
                { link: customerNavigationItems.Customer },
                { link: customerNavigationItems.EditCustomer },
                { link: customerNavigationItems.Users },
                { link: customerNavigationItems.Logging },
                { link: customerNavigationItems.RelatedCustomer },
                { link: customerNavigationItems.UpdateAddress },
                { link: customerNavigationItems.Collaborations },
                { link: customerNavigationItems.Agreements },
                { link: customerNavigationItems.Discounts },
                { link: customerNavigationItems.CompanyData }
            ]
        }
    },
    {
        link: {
            title: 'customernavigation.sales',
            subItems: [
                { link: customerNavigationItems.PlaceOrder },
                { link: customerNavigationItems.Leads },
                { link: customerNavigationItems.Appointments },
                { link: customerNavigationItems.SendLeads },
                { link: customerNavigationItems.Campaigns }
            ]
        }
    },
    {
        link: {
            title: 'customernavigation.education',
            subItems: [
                { link: customerNavigationItems.Courses },
                { link: customerNavigationItems.Movies },
                { link: customerNavigationItems.Onboarding },
                { link: customerNavigationItems.EducationCode },
            ],
        }
    },
    { link: customerNavigationItems.EmailForms },
    {
        link: {
            title: 'customernavigation.admin',
            subItems: [
                { link: customerNavigationItems.DesktopVersion },
                { link: customerNavigationItems.Compensation },
                { link: customerNavigationItems.Consulting },
                { link: customerNavigationItems.Invoices }
            ]
        }
    },
    {
        link: {
            title: 'customernavigation.externalLinks',
            subItems: [
                { link: customerNavigationItems.AiAssistant },
                { link: customerNavigationItems.Salesforce },
                { link: customerNavigationItems.InternalAdmin },
                { link: customerNavigationItems.FileBox },
                { link: customerNavigationItems.IntegrationPartners },
                { link: customerNavigationItems.Retailer },
                { link: customerNavigationItems.TerminationOfAdditionalUsersOnPrem },
                { link: customerNavigationItems.ConnectSupportTool }
            ]
        }
    }
]